// Module
var code = "<div class=\"kform-file-label\"> <icon class=\"icon\" mimetype=\"$ctrl.file.mimetype || $ctrl.file.type\" ng-if=\"$ctrl.file.name\"></icon> <b>{{ $ctrl.file.name.user || $ctrl.file.name }}</b> <span ng-if=\"$ctrl.file.size\">({{ $ctrl.file.size | humanSize }})</span> </div> ";
// Exports
export default code;